<template>
  <div :class="status">
    <span class="badge-dot" :class="status + '-dot'"></span>
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    status: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.not_started {
  color: #ea8f1c;
}
.not_started-dot {
  background-color: #ea8f1c;
}
.expired {
  color: #858a9a;
}
.expired-dot {
  background-color: #858a9a;
}
.processing {
  color: #2cb9b8;
}
.processing-dot {
  background-color: #2cb9b8;
}
.waiting {
  color: #2CB9B8;
}
.waiting-dot {
  background-color: #2CB9B8;
}
.delivered {
  color: #40A90C;
}
.delivered-dot {
  background-color: #40A90C;
}
._processing {
  color: #EA8F1C;
}
._processing-dot {
  background-color: #EA8F1C;
}
.cancelled {
  color: #858A9A;
}
.cancelled-dot {
  background-color: #858A9A;
}
.fail {
  color: #E84A4A;
}
.fail-dot {
  background-color: #E84A4A;
}
.badge-dot {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}
.text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  margin-left: 8px;
  line-height: 20px;
}
</style>
